export const ICONS_SYSTEM = [
    'SvgAccount',
    'SvgAddCircle',
    'SvgAddSquare',
    'SvgAlert',
    'SvgArrowUp',
    'SvgArrowRight',
    'SvgArrowDown',
    'SvgArrowLeft',
    'SvgBadge',
    'SvgBookmark',
    'SvgBuilding',
    'SvgBusiness',
    'SvgCalendar',
    'SvgCamera',
    'SvgCart',
    'SvgCategory',
    'SvgChallenge',
    'SvgChefHat',
    'SvgCloseCircle',
    'SvgCoupon',
    'SvgCreditCard',
    'SvgDelete',
    'SvgDeliveryBike',
    'SvgDeliveryVan',
    'SvgDineIn',
    'SvgDislike',
    'SvgDonate',
    'SvgEdit',
    'SvgFavourite',
    'SvgFilter',
    'SvgFlash',
    'SvgGift',
    'SvgGlutenFree',
    'SvgHalal',
    'SvgHealthierChoice',
    'SvgHelp',
    'SvgHide',
    'SvgHome',
    'SvgInfo',
    'SvgLike',
    'SvgLinkOut',
    'SvgList',
    'SvgLocation',
    'SvgLocationPin',
    'SvgLogin',
    'SvgLogout',
    'SvgIdentity',
    'SvgMenuHamb',
    'SvgMinusCircle',
    'SvgNoInternet',
    'SvgNotification',
    'SvgOrders',
    'SvgPot',
    'SvgPromotion',
    'SvgQrCode',
    'SvgScales',
    'SvgScan',
    'SvgSearch',
    'SvgSettings',
    'SvgShare',
    'SvgShow',
    'SvgStar',
    'SvgStore',
    'SvgSuccess',
    'SvgTakeaway',
    'SvgClock',
    'SvgTips',
    'SvgTransFatFree',
    'SvgTrophy',
    'SvgUser',
    'SvgVegetarian',
    'SvgWhisk',
    'SvgWine'
];
export const ICONS_SYSTEM_NO_FILLED = [
    'SvgArrowDoubleUp',
    'SvgArrowDoubleRight',
    'SvgArrowDoubleDown',
    'SvgArrowDoubleLeft',
    'SvgAdd',
    'SvgMinus',
    'SvgClose',
    'SvgTick',
    'SvgMenuMoreHorizontal',
    'SvgMenuMoreVertical',
    'SvgHistory',
    'SvgLoading',
    'SvgLinkPlus',
    'SvgLinkPoints',
    'SvgArrowUpward',
    'SvgTrendingUp',
    'SvgDirectionalArrowLeft',
    'SvgDirectionalArrowRight',
    'SvgOrderNote'
];
export const ICONS_SOCIAL_MEDIA = [
    'SvgFacebook',
    'SvgInstagram',
    'SvgApple',
    'SvgGoogle',
    'SvgSpotify',
    'SvgYoutube'
];
export const ICONS_ALL = [
    ...ICONS_SYSTEM,
    ...ICONS_SYSTEM_NO_FILLED,
    ...ICONS_SOCIAL_MEDIA
];
export const ICONS_DECOMMISSION = ['SvgBack', 'SvgCheck', 'SvgProfile', 'SvgVerified'];
//# sourceMappingURL=icon-group.js.map